
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/internal-data-management",
      function () {
        return require("private-next-pages/solutions/internal-data-management.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/internal-data-management"])
      });
    }
  